export const DEFAULT_PREFERENCE_VALUES = {
	colorScheme: 'snow',
	gridVisible: false,
	layoutEdit: true,
	dateRange: 'Last 180 days'
};

